import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../utils/Auth/AuthProvider";

export const NonAuthRoute = () => {
    const { token } = useAuth();
  
    // If the user is NOT authenticated, allow access to auth pages (render children)
    if (!token) {
      return <Outlet />;
    }
  
    // If authenticated, redirect away from auth pages to home
    return <Navigate to="/" />;
  };